module.exports = __webpack_public_path__ + "static/l2-content1-oval-799c16cdd3643b51cd554d8693bcaca1.png";